export const migrateReportIsV3Published = (report: ReportType) => {
  return report.access.type !== 'Private';
};

export const migrateReportV3Access = (report: ReportType) => {
  return {
    isPublic: report.access.type === 'Public',
    userIds: report.access.userIds || [],
    groupIds: [],
  };
};

export const migrateScorecardIsV3Published = (
  scorecard: Scorecards.Scorecard,
) => {
  return scorecard.assigneeId.length > 0;
};

export const migrateScorecardV3Access = (scorecard: Scorecards.Scorecard) => {
  return {
    isPublic: false,
    userIds: scorecard.assigneeId || [],
    groupIds: [],
  };
};

export const migrateDashboardIsV3Published = (dashboard: DashboardType) => {
  return dashboard.access.type !== 'Private';
};

export const migrateDashboardV3Access = (dashboard: DashboardType) => {
  return {
    isPublic: dashboard.access.type === 'Public',
    userIds: dashboard.access.userIds || [],
    groupIds: [],
  };
};
